import IfGlobalOrg from '@/components/organizations/IfGlobalOrg'
import { InfoNotice } from '@/components/patterns/info-notice'
import { Button } from '@/components/ui/button'
import { usePathHelper } from '@/hooks/usePathHelper'
import { useAbility } from '@/lib/casl'
import { stripeOnboardingLink } from '@/lib/stripe-financial-routes'
import { Link, useParams } from '@tanstack/react-router'
import { AlertCircle, ExternalLink } from 'lucide-react'

export function SetupRequirementsCards({
  showLocationsCard,
  showStripeCard,
  locationsDescription,
  stripeDescription,
}) {
  const { orgId } = useParams({ strict: false })
  const pathHelper = usePathHelper()
  const ability = useAbility()
  const locationsLink = pathHelper.locations?.index?.()
  const stripeSetupLink =
    orgId && ability.can('edit', 'stripe-account') ? stripeOnboardingLink(orgId) : null
  const stripeCard = showStripeCard ? (
    <InfoNotice
      className="mb-4"
      title="Stripe Connect Required"
      tone="warning"
      icon={<AlertCircle />}
      action={
        stripeSetupLink ? (
          <Button asChild variant="secondary" className="shrink-0">
            <Link {...stripeSetupLink}>
              <ExternalLink className="h-4 w-4" />
              Go to Stripe Setup
            </Link>
          </Button>
        ) : null
      }
    >
      {stripeDescription}
    </InfoNotice>
  ) : null

  return (
    <div className="space-y-4">
      {showLocationsCard && (
        <InfoNotice
          title="Locations Required"
          tone="warning"
          icon={<AlertCircle />}
          action={
            locationsLink ? (
              <Button asChild variant="secondary" className="shrink-0">
                <Link {...locationsLink.link}>
                  <ExternalLink className="h-4 w-4" />
                  Go to Locations
                </Link>
              </Button>
            ) : null
          }
        >
          {locationsDescription}
        </InfoNotice>
      )}

      <IfGlobalOrg fallback={stripeCard}>
        <InfoNotice className="mb-4" title="This is the global organization" tone="global">
          Do not set up a Stripe Connect account.
        </InfoNotice>
      </IfGlobalOrg>
    </div>
  )
}

export default SetupRequirementsCards
